import { render } from "./FileImageSelector.vue?vue&type=template&id=28438aca&scoped=true"
import script from "./FileImageSelector.vue?vue&type=script&lang=js"
export * from "./FileImageSelector.vue?vue&type=script&lang=js"

import "./FileImageSelector.vue?vue&type=style&index=0&id=28438aca&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28438aca"]])

export default __exports__